import BlockCodingContent from "../Coding/BlockCodingContent";

export default function FullBlock(props) {
  const { header, detailsName } = props;

  return (
    <div className="mb-16">
      <h2 className="text-2xl font-semibold text-foreground mb-6 pb-3 border-b border-border">
        {header}
      </h2>
      <div className="space-y-4">
        {detailsName.map((project, index) => {
          const { title, description, contribution, link } = project;
          return (
            <BlockCodingContent
              key={index}
              title={title}
              description={description}
              contribution={contribution}
              link={link}
            />
          );
        })}
      </div>
    </div>
  );
}
